import { useMutation } from '@tanstack/react-query';

import { serviceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

const validateServiceKey: serviceTypes.ValidateServiceKey = (
  data
): Promise<{ exists: boolean }> => {
  return axios.post(`/services/keys/validate`, data);
};

type ValidateServiceOptions = {
  config?: MutationConfig<typeof validateServiceKey>;
};

export function useValidateServiceKey({ config = {} }: ValidateServiceOptions = {}) {
  return useMutation({
    ...config,
    mutationFn: validateServiceKey,
  });
}
